module.exports = __webpack_public_path__ + "img/shooting08.6a9d76e4.jpeg";